// Code generated by protoc-gen-ts. DO NOT EDIT.
// protoc-gen-ts is an Art Processors production, found in mos-sdk-py.

import { Metadata } from "generated/mos/entity";
import { PlacedPoint } from "generated/mos/geo";
import { AmenityCategoryType, AmenityCategoryTypeValues } from "generated/mos/org/getty/analytics";
import { TranslatableStringValue } from "generated/mos/translatable";
import { Codec, DecodeContext, RemoteObject, WebRPCError, decodeMessageRepeated, ensureScalar, stripTypePropertyDeep } from "generated/webrpc";

export namespace Amenity {
  export type Ref = { readonly typename: 'mos.org.getty.visitor_info.Amenity', readonly id: string };
  export function isRef(v: { typename: string, id: string } | undefined): v is Ref {
    return !!v && typeof v.id === "string" && (v.typename === 'mos.org.getty.visitor_info.Amenity');
  }
  export function mustRef(v: { typename: string, id: string } | undefined): Ref {
    if (!isRef(v)) throw new WebRPCError(`Ref ${v && v.typename}:${v && v.id} is not a valid ref for a Amenity`);
    return v;
  }
  export const refName = "mos.org.getty.visitor_info.Amenity" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly ref: { readonly typename: 'mos.org.getty.visitor_info.Amenity', readonly id: string } | undefined,
    readonly amenityCategoryRef: { readonly typename: 'mos.org.getty.visitor_info.VisitorInfoPage', readonly id: string } | undefined,
    readonly name: TranslatableStringValue.Entity | undefined,
    readonly headerImageRef: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
    readonly headerImageAltText: TranslatableStringValue.Entity | undefined,
    readonly openingHoursText: TranslatableStringValue.Entity | undefined,
    readonly descriptionText: TranslatableStringValue.Entity | undefined,
    readonly locationText: TranslatableStringValue.Entity | undefined,
    readonly mapPdfRef: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
    readonly defaultMapZoomFrame: Rectangle.Entity | undefined,
    // Accessibility description for the map, presented to screen readers as a substitute for the map content.
    readonly mapAltText: TranslatableStringValue.Entity | undefined,
    readonly location: PlacedPoint.Entity | undefined,
    readonly wayfindingMapRef: { readonly typename: 'mos.org.getty.audio.WayfindingMap', readonly id: string } | undefined,
    readonly extendedDescriptionText: TranslatableStringValue.Entity | undefined,
    // images used for icon display on SiteMap
    readonly iconImageRef: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
    readonly iconSelectedImageRef: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
    amenityCategoryRef: undefined,
    name: undefined,
    headerImageRef: undefined,
    headerImageAltText: undefined,
    openingHoursText: undefined,
    descriptionText: undefined,
    locationText: undefined,
    mapPdfRef: undefined,
    defaultMapZoomFrame: undefined,
    mapAltText: undefined,
    location: undefined,
    wayfindingMapRef: undefined,
    extendedDescriptionText: undefined,
    iconImageRef: undefined,
    iconSelectedImageRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["ref"] = v.ref;
      obj["amenityCategoryRef"] = v.amenityCategoryRef;
      obj["name"] = TranslatableStringValue.codec.encode(v.name);
      obj["headerImageRef"] = v.headerImageRef;
      obj["headerImageAltText"] = TranslatableStringValue.codec.encode(v.headerImageAltText);
      obj["openingHoursText"] = TranslatableStringValue.codec.encode(v.openingHoursText);
      obj["descriptionText"] = TranslatableStringValue.codec.encode(v.descriptionText);
      obj["locationText"] = TranslatableStringValue.codec.encode(v.locationText);
      obj["mapPdfRef"] = v.mapPdfRef;
      obj["defaultMapZoomFrame"] = Rectangle.codec.encode(v.defaultMapZoomFrame);
      obj["mapAltText"] = TranslatableStringValue.codec.encode(v.mapAltText);
      obj["location"] = PlacedPoint.codec.encode(v.location);
      obj["wayfindingMapRef"] = v.wayfindingMapRef;
      obj["extendedDescriptionText"] = TranslatableStringValue.codec.encode(v.extendedDescriptionText);
      obj["iconImageRef"] = v.iconImageRef;
      obj["iconSelectedImageRef"] = v.iconSelectedImageRef;
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info.Amenity");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      out["amenityCategoryRef"] = v["amenityCategoryRef"];
      out["name"] = ctx.decode(TranslatableStringValue.codec, v["name"], "name");
      out["headerImageRef"] = v["headerImageRef"];
      out["headerImageAltText"] = ctx.decode(TranslatableStringValue.codec, v["headerImageAltText"], "headerImageAltText");
      out["openingHoursText"] = ctx.decode(TranslatableStringValue.codec, v["openingHoursText"], "openingHoursText");
      out["descriptionText"] = ctx.decode(TranslatableStringValue.codec, v["descriptionText"], "descriptionText");
      out["locationText"] = ctx.decode(TranslatableStringValue.codec, v["locationText"], "locationText");
      out["mapPdfRef"] = v["mapPdfRef"];
      out["defaultMapZoomFrame"] = ctx.decode(Rectangle.codec, v["defaultMapZoomFrame"], "defaultMapZoomFrame");
      out["mapAltText"] = ctx.decode(TranslatableStringValue.codec, v["mapAltText"], "mapAltText");
      out["location"] = ctx.decode(PlacedPoint.codec, v["location"], "location");
      out["wayfindingMapRef"] = v["wayfindingMapRef"];
      out["extendedDescriptionText"] = ctx.decode(TranslatableStringValue.codec, v["extendedDescriptionText"], "extendedDescriptionText");
      out["iconImageRef"] = v["iconImageRef"];
      out["iconSelectedImageRef"] = v["iconSelectedImageRef"];
      return out as any as Entity;
    }
  }();
}

export namespace DeepDiveLink {
  export const refName = "mos.org.getty.visitor_info.DeepDiveLink" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly title: TranslatableStringValue.Entity | undefined,
    readonly webpageUrl: TranslatableStringValue.Entity | undefined,
    readonly contextTitle: TranslatableStringValue.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    title: undefined,
    webpageUrl: undefined,
    contextTitle: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      return stripTypePropertyDeep(v);
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info.DeepDiveLink");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["title"] = ctx.decode(TranslatableStringValue.codec, v["title"], "title");
      out["webpageUrl"] = ctx.decode(TranslatableStringValue.codec, v["webpageUrl"], "webpageUrl");
      out["contextTitle"] = ctx.decode(TranslatableStringValue.codec, v["contextTitle"], "contextTitle");
      return out as any as Entity;
    }
  }();
}

export namespace DeepDiveMood {
  export const refName = "mos.org.getty.visitor_info.DeepDiveMood" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly moodRef: { readonly typename: 'mos.org.getty.audio.Mood', readonly id: string } | undefined,
    readonly deepDiveLinks: ReadonlyArray<DeepDiveLink.Entity>,
  }
  export const defaults: Entity = {
    type: refName,
    moodRef: undefined,
    deepDiveLinks: [],
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      return stripTypePropertyDeep(v);
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info.DeepDiveMood");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["moodRef"] = v["moodRef"];
      out["deepDiveLinks"] = decodeMessageRepeated(ctx, DeepDiveLink.codec, v["deepDiveLinks"], "deepDiveLinks");
      return out as any as Entity;
    }
  }();
}

// Used to specify zoom frames for map images
export namespace Rectangle {
  export const refName = "mos.org.getty.visitor_info.Rectangle" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly top: number,
    readonly bottom: number,
    readonly left: number,
    readonly right: number,
  }
  export const defaults: Entity = {
    type: refName,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info.Rectangle");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["top"] = ensureScalar(ctx, v["top"], "number");
      out["bottom"] = ensureScalar(ctx, v["bottom"], "number");
      out["left"] = ensureScalar(ctx, v["left"], "number");
      out["right"] = ensureScalar(ctx, v["right"], "number");
      return out as any as Entity;
    }
  }();
}

export namespace VisitorInfoPage {
  export type Ref = { readonly typename: 'mos.org.getty.visitor_info.VisitorInfoPage', readonly id: string };
  export function isRef(v: { typename: string, id: string } | undefined): v is Ref {
    return !!v && typeof v.id === "string" && (v.typename === 'mos.org.getty.visitor_info.VisitorInfoPage');
  }
  export function mustRef(v: { typename: string, id: string } | undefined): Ref {
    if (!isRef(v)) throw new WebRPCError(`Ref ${v && v.typename}:${v && v.id} is not a valid ref for a VisitorInfoPage`);
    return v;
  }
  export const refName = "mos.org.getty.visitor_info.VisitorInfoPage" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly ref: { readonly typename: 'mos.org.getty.visitor_info.VisitorInfoPage', readonly id: string } | undefined,
    // Owned by
    readonly siteContentRef: { readonly typename: 'mos.org.getty.visitor_info.VisitorInfoSiteContent', readonly id: string } | undefined,
    readonly metadata: Metadata.Entity | undefined,
    readonly listTitle: TranslatableStringValue.Entity | undefined,
    // list_icon_ref is optional
    readonly listIconRef: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
    readonly pageProperties: VisitorInfoPage.SectionSeparator.Entity | VisitorInfoPage.SiteMap.Entity | VisitorInfoPage.StaticWebPage.Entity | VisitorInfoPage.URLWebPage.Entity | VisitorInfoPage.AppPage.Entity | VisitorInfoPage.AmenityCategory.Entity | VisitorInfoPage.DeepDivePage.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
    siteContentRef: undefined,
    metadata: undefined,
    listTitle: undefined,
    listIconRef: undefined,
    pageProperties: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["ref"] = v.ref;
      obj["siteContentRef"] = v.siteContentRef;
      obj["metadata"] = Metadata.codec.encode(v.metadata);
      obj["listTitle"] = TranslatableStringValue.codec.encode(v.listTitle);
      obj["listIconRef"] = v.listIconRef;
      {
        const uv: any = v.pageProperties;
        if (uv !== undefined) {
          if (uv.type == "mos.org.getty.visitor_info.VisitorInfoPage.AmenityCategory") {
            obj["amenityCategory"] = VisitorInfoPage.AmenityCategory.codec.encode(uv);
          }
          else if (uv.type == "mos.org.getty.visitor_info.VisitorInfoPage.AppPage") {
            obj["appPage"] = VisitorInfoPage.AppPage.codec.encode(uv);
          }
          else if (uv.type == "mos.org.getty.visitor_info.VisitorInfoPage.DeepDivePage") {
            obj["deepDivePage"] = VisitorInfoPage.DeepDivePage.codec.encode(uv);
          }
          else if (uv.type == "mos.org.getty.visitor_info.VisitorInfoPage.SectionSeparator") {
            obj["sectionSeparator"] = VisitorInfoPage.SectionSeparator.codec.encode(uv);
          }
          else if (uv.type == "mos.org.getty.visitor_info.VisitorInfoPage.SiteMap") {
            obj["siteMap"] = VisitorInfoPage.SiteMap.codec.encode(uv);
          }
          else if (uv.type == "mos.org.getty.visitor_info.VisitorInfoPage.StaticWebPage") {
            obj["staticWebPage"] = VisitorInfoPage.StaticWebPage.codec.encode(uv);
          }
          else if (uv.type == "mos.org.getty.visitor_info.VisitorInfoPage.URLWebPage") {
            obj["urlWebPage"] = VisitorInfoPage.URLWebPage.codec.encode(uv);
          }
          else {
            throw new WebRPCError("union discrimination failed for .mos.org.getty.visitor_info.VisitorInfoPage.page_properties");
          }
        }
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info.VisitorInfoPage");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      out["siteContentRef"] = v["siteContentRef"];
      out["metadata"] = ctx.decode(Metadata.codec, v["metadata"], "metadata");
      out["listTitle"] = ctx.decode(TranslatableStringValue.codec, v["listTitle"], "listTitle");
      out["listIconRef"] = v["listIconRef"];
      {
        if (v["amenityCategory"] !== undefined) {
          out["pageProperties"] = ctx.decode(VisitorInfoPage.AmenityCategory.codec, v["amenityCategory"], "amenityCategory");
        }
        if (v["appPage"] !== undefined) {
          out["pageProperties"] = ctx.decode(VisitorInfoPage.AppPage.codec, v["appPage"], "appPage");
        }
        if (v["deepDivePage"] !== undefined) {
          out["pageProperties"] = ctx.decode(VisitorInfoPage.DeepDivePage.codec, v["deepDivePage"], "deepDivePage");
        }
        if (v["sectionSeparator"] !== undefined) {
          out["pageProperties"] = ctx.decode(VisitorInfoPage.SectionSeparator.codec, v["sectionSeparator"], "sectionSeparator");
        }
        if (v["siteMap"] !== undefined) {
          out["pageProperties"] = ctx.decode(VisitorInfoPage.SiteMap.codec, v["siteMap"], "siteMap");
        }
        if (v["staticWebPage"] !== undefined) {
          out["pageProperties"] = ctx.decode(VisitorInfoPage.StaticWebPage.codec, v["staticWebPage"], "staticWebPage");
        }
        if (v["urlWebPage"] !== undefined) {
          out["pageProperties"] = ctx.decode(VisitorInfoPage.URLWebPage.codec, v["urlWebPage"], "urlWebPage");
        }
      }
      return out as any as Entity;
    }
  }();
  export namespace SectionSeparator {
    export const refName = "mos.org.getty.visitor_info.VisitorInfoPage.SectionSeparator" as const;
    export type Entity = {
      readonly type: typeof refName,
    }
    export const defaults: Entity = {
      type: refName,
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const { type, ...out } = v;
        return out;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info.VisitorInfoPage.SectionSeparator");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        return out as any as Entity;
      }
    }();
  }

  export namespace SiteMap {
    export const refName = "mos.org.getty.visitor_info.VisitorInfoPage.SiteMap" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly headerTitle: TranslatableStringValue.Entity | undefined,
      readonly mapPdfRef: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
      readonly defaultMapZoomFrame: Rectangle.Entity | undefined,
      readonly altText: TranslatableStringValue.Entity | undefined,
    }
    export const defaults: Entity = {
      type: refName,
      headerTitle: undefined,
      mapPdfRef: undefined,
      defaultMapZoomFrame: undefined,
      altText: undefined,
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        return stripTypePropertyDeep(v);
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info.VisitorInfoPage.SiteMap");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["headerTitle"] = ctx.decode(TranslatableStringValue.codec, v["headerTitle"], "headerTitle");
        out["mapPdfRef"] = v["mapPdfRef"];
        out["defaultMapZoomFrame"] = ctx.decode(Rectangle.codec, v["defaultMapZoomFrame"], "defaultMapZoomFrame");
        out["altText"] = ctx.decode(TranslatableStringValue.codec, v["altText"], "altText");
        return out as any as Entity;
      }
    }();
  }

  export namespace StaticWebPage {
    export const refName = "mos.org.getty.visitor_info.VisitorInfoPage.StaticWebPage" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly pageHtmlSource: TranslatableStringValue.Entity | undefined,
      readonly navigationMode: WebPageNavigationMode,
    }
    export const defaults: Entity = {
      type: refName,
      pageHtmlSource: undefined,
      navigationMode: "WEB_PAGE_NAVIGATION_MODE_UNSPECIFIED",
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        return stripTypePropertyDeep(v);
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info.VisitorInfoPage.StaticWebPage");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["pageHtmlSource"] = ctx.decode(TranslatableStringValue.codec, v["pageHtmlSource"], "pageHtmlSource");
        {
          const ev = ensureScalar(ctx, v["navigationMode"], "string") || defaults["navigationMode"];
          if (!WebPageNavigationModeValues.has(ev as any)) {
            throw ctx.error(`unknown value "${ev}" for enum .mos.org.getty.visitor_info.WebPageNavigationMode`);
          }
          out["navigationMode"] = ev as any;
        }
        return out as any as Entity;
      }
    }();
  }

  export namespace URLWebPage {
    export const refName = "mos.org.getty.visitor_info.VisitorInfoPage.URLWebPage" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly pageUrl: TranslatableStringValue.Entity | undefined,
      readonly navigationMode: WebPageNavigationMode,
    }
    export const defaults: Entity = {
      type: refName,
      pageUrl: undefined,
      navigationMode: "WEB_PAGE_NAVIGATION_MODE_UNSPECIFIED",
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        return stripTypePropertyDeep(v);
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info.VisitorInfoPage.URLWebPage");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["pageUrl"] = ctx.decode(TranslatableStringValue.codec, v["pageUrl"], "pageUrl");
        {
          const ev = ensureScalar(ctx, v["navigationMode"], "string") || defaults["navigationMode"];
          if (!WebPageNavigationModeValues.has(ev as any)) {
            throw ctx.error(`unknown value "${ev}" for enum .mos.org.getty.visitor_info.WebPageNavigationMode`);
          }
          out["navigationMode"] = ev as any;
        }
        return out as any as Entity;
      }
    }();
  }

  export namespace AppPage {
    export const refName = "mos.org.getty.visitor_info.VisitorInfoPage.AppPage" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly pageType: VisitorInfoPage.AppPage.PageType,
    }
    export const defaults: Entity = {
      type: refName,
      pageType: "PAGE_TYPE_UNSPECIFIED",
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const { type, ...out } = v;
        return out;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info.VisitorInfoPage.AppPage");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        {
          const ev = ensureScalar(ctx, v["pageType"], "string") || defaults["pageType"];
          if (!VisitorInfoPage.AppPage.PageTypeValues.has(ev as any)) {
            throw ctx.error(`unknown value "${ev}" for enum .mos.org.getty.visitor_info.VisitorInfoPage.AppPage.PageType`);
          }
          out["pageType"] = ev as any;
        }
        return out as any as Entity;
      }
    }();
    export const PageTypeValues = new Set([
      'PAGE_TYPE_UNSPECIFIED' as const,
      'PAGE_TYPE_SETTINGS' as const,
      'PAGE_TYPE_ABOUT_APP' as const,
    ]);
    export type PageType = typeof PageTypeValues extends Set<infer U> ? U : never;

  }

  export namespace AmenityCategory {
    export const refName = "mos.org.getty.visitor_info.VisitorInfoPage.AmenityCategory" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly amenityRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.visitor_info.Amenity', readonly id: string }>,
      readonly headerTitle: TranslatableStringValue.Entity | undefined,
      readonly headerImageRef: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
      readonly headerImageAltText: TranslatableStringValue.Entity | undefined,
      readonly descriptionText: TranslatableStringValue.Entity | undefined,
      readonly categoryType: AmenityCategoryType,
    }
    export const defaults: Entity = {
      type: refName,
      amenityRefs: [],
      headerTitle: undefined,
      headerImageRef: undefined,
      headerImageAltText: undefined,
      descriptionText: undefined,
      categoryType: "UNSET",
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        return stripTypePropertyDeep(v);
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info.VisitorInfoPage.AmenityCategory");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["amenityRefs"] = v["amenityRefs"];
        out["headerTitle"] = ctx.decode(TranslatableStringValue.codec, v["headerTitle"], "headerTitle");
        out["headerImageRef"] = v["headerImageRef"];
        out["headerImageAltText"] = ctx.decode(TranslatableStringValue.codec, v["headerImageAltText"], "headerImageAltText");
        out["descriptionText"] = ctx.decode(TranslatableStringValue.codec, v["descriptionText"], "descriptionText");
        {
          const ev = ensureScalar(ctx, v["categoryType"], "string") || defaults["categoryType"];
          if (!AmenityCategoryTypeValues.has(ev as any)) {
            throw ctx.error(`unknown value "${ev}" for enum .mos.org.getty.analytics.AmenityCategoryType`);
          }
          out["categoryType"] = ev as any;
        }
        return out as any as Entity;
      }
    }();
  }

  export namespace DeepDivePage {
    export const refName = "mos.org.getty.visitor_info.VisitorInfoPage.DeepDivePage" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly headerTitle: TranslatableStringValue.Entity | undefined,
      readonly headerImageRef: { readonly typename: 'mos.media.Media', readonly id: string } | undefined,
      readonly headerImageAltText: TranslatableStringValue.Entity | undefined,
      readonly descriptionText: TranslatableStringValue.Entity | undefined,
      readonly deepDiveMoods: ReadonlyArray<DeepDiveMood.Entity>,
    }
    export const defaults: Entity = {
      type: refName,
      headerTitle: undefined,
      headerImageRef: undefined,
      headerImageAltText: undefined,
      descriptionText: undefined,
      deepDiveMoods: [],
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        return stripTypePropertyDeep(v);
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info.VisitorInfoPage.DeepDivePage");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["headerTitle"] = ctx.decode(TranslatableStringValue.codec, v["headerTitle"], "headerTitle");
        out["headerImageRef"] = v["headerImageRef"];
        out["headerImageAltText"] = ctx.decode(TranslatableStringValue.codec, v["headerImageAltText"], "headerImageAltText");
        out["descriptionText"] = ctx.decode(TranslatableStringValue.codec, v["descriptionText"], "descriptionText");
        out["deepDiveMoods"] = decodeMessageRepeated(ctx, DeepDiveMood.codec, v["deepDiveMoods"], "deepDiveMoods");
        return out as any as Entity;
      }
    }();
  }

}

// VisitorInfoSiteContent represents all of the Visitor Info content for a given site
export namespace VisitorInfoSiteContent {
  export type Ref = { readonly typename: 'mos.org.getty.visitor_info.VisitorInfoSiteContent', readonly id: string };
  export function isRef(v: { typename: string, id: string } | undefined): v is Ref {
    return !!v && typeof v.id === "string" && (v.typename === 'mos.org.getty.visitor_info.VisitorInfoSiteContent');
  }
  export function mustRef(v: { typename: string, id: string } | undefined): Ref {
    if (!isRef(v)) throw new WebRPCError(`Ref ${v && v.typename}:${v && v.id} is not a valid ref for a VisitorInfoSiteContent`);
    return v;
  }
  export const refName = "mos.org.getty.visitor_info.VisitorInfoSiteContent" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly ref: { readonly typename: 'mos.org.getty.visitor_info.VisitorInfoSiteContent', readonly id: string } | undefined,
    readonly siteRef: { readonly typename: 'mos.structure.Site', readonly id: string } | undefined,
    readonly visitorInfoPageRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.visitor_info.VisitorInfoPage', readonly id: string }>,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
    siteRef: undefined,
    visitorInfoPageRefs: [],
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.visitor_info.VisitorInfoSiteContent");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      out["siteRef"] = v["siteRef"];
      out["visitorInfoPageRefs"] = v["visitorInfoPageRefs"];
      return out as any as Entity;
    }
  }();
}

export const WebPageNavigationModeValues = new Set([
  'WEB_PAGE_NAVIGATION_MODE_UNSPECIFIED' as const,
  'WEB_PAGE_NAVIGATION_MODE_DISALLOWED' as const,
  'WEB_PAGE_NAVIGATION_MODE_MODAL' as const,
]);
export type WebPageNavigationMode = typeof WebPageNavigationModeValues extends Set<infer U> ? U : never;

